import classNames from 'classnames';
import Styles from './Procedure.module.scss';

export interface ProcedureProps {
    item: {
        StatusIndicator: number;
        Modality_Text: string;
        Description: string;
        Room_Text: string | null;
        Radiologist_Text: string | null;
        Color: string;
        Code: string;
    };
}

export function Procedure(props: Readonly<ProcedureProps>): React.ReactElement {
    const { StatusIndicator, Modality_Text: ModalityText, Description, Room_Text: RoomText, Radiologist_Text: RadiologistText, Color, Code } = props.item;

    let extraStyle = '';
    switch (StatusIndicator) {
        case 1:
            extraStyle = Styles.started;
            break;
        case 2:
            extraStyle = Styles.finished;
            break;
        case 3:
            extraStyle = Styles.correction;
            break;
        case 4:
            extraStyle = Styles.cancelled;
            break;
        case 5:
            extraStyle = Styles.control;
            break;
    }

    const title = `${ModalityText} - ${Description}\n${RoomText ?? ''} - ${RadiologistText ?? ''}`;

    return (
        <div className={classNames(Styles.item, extraStyle)} style={{ backgroundColor: Color }} title={title}>
            <b>{ ModalityText }</b>
            { ' ' }
            { Code }
        </div>
    );
}
